import React from "react";
import { $ } from "../utils/Utils";
import { dataMapStyles } from "../utils/Data";
import MapInfo from "./MapInfo";
import "./Map.css";

let arrMarkers = [];
let markersColors = ["gray", "red", "yellow", "green"]; // gray unused
let markersSizes = ["small", "medium", "large"];
let markerSize = 0;
// let idleListener = 0;

export default class Map extends React.Component {
  constructor() {
    super();
    this.state = { info: {} };
  }

  componentDidMount() {
    this.setMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.info === prevState.info) {
      this.setMap();
    }
  }
  componentWillUnmount() {
    // infowindow.close();
    // idleListener.remove();
  }

  setMap() {
    if (this.props.mapGoogle && this.props.mapItems) {
      const google = this.props.mapGoogle;
      const googlemap = this.showMap(google);
      this.showItems(google, googlemap, this.props.mapItems);
    }
  }

  showMap(google) {
    let googlemap = new google.maps.Map($("#map-canvas"), {
      center: {
        lat: -9.9,
        lng: -75
      },
      zoom: 6,
      disableDefaultUI: true,
      // zoomControl: true,
      // zoomControlOptions: {
      //   position: google.maps.ControlPosition.RIGHT_CENTER
      // },
      styles: dataMapStyles()
    });
    googlemap.addListener("zoom_changed", function() {
      let zoom = googlemap.getZoom();
      if (zoom < 7) {
        if (markerSize !== 0) {
          markerSize = 0;
          for (const item of arrMarkers) {
            item.h.setIcon(
              `../img/marker--${markersSizes[markerSize]}--${
                markersColors[item.h.lights]
              }.png`
            );
          }
        }
      } else if (zoom > 8) {
        if (markerSize !== 2) {
          markerSize = 2;
          for (const item of arrMarkers) {
            item.h.setIcon(
              `../img/marker--${markersSizes[markerSize]}--${
                markersColors[item.h.lights]
              }.png`
            );
          }
        }
      } else {
        if (markerSize !== 1) {
          markerSize = 1;
          for (const item of arrMarkers) {
            item.h.setIcon(
              `../img/marker--${markersSizes[markerSize]}--${
                markersColors[item.h.lights]
              }.png`
            );
          }
        }
      }
    });
    // idleListener = googlemap.addListener('idle', function() {
    //   let bounds = googlemap.getBounds();
    //   for (const item of arrMarkers) {
    //     if (bounds.contains(item.h.position)) {
    //       if (item.h.map !== googlemap) {
    //         item.h.setMap(googlemap);
    //       }
    //     } else {
    //       item.h.setMap(null);
    //     }
    //   }
    // });
    return googlemap;
  }

  showItems(google, googlemap, mapItems) {
    let infowindow = new google.maps.InfoWindow();
    for (const item of mapItems) {
      let point = new google.maps.LatLng(item.latitud, item.longitud);
      let marker = new google.maps.Marker({
        map: googlemap,
        position: point,
        lights: item.semaforo,
        icon: `../img/marker--${markersSizes[markerSize]}--${
          markersColors[item.semaforo]
        }.png`
      }).addListener("click", () => {
        googlemap.panTo(point);
        infowindow.setContent(`I.E. ${item.nombre}`);
        infowindow.open(googlemap, marker.l);
        $(".info").style.display = "block";
        $(".point").style.background = `url("../img/marker--large--${
          markersColors[item.semaforo]
        }.png")`;
        this.setState({ info: item });
      });
      arrMarkers.push(marker);
    }
    infowindow.addListener("closeclick", function() {
      $(".info").style.display = "none";
    });

    $(".info-close").addEventListener("click", function() {
      $(".info").style.display = "none";
      infowindow.close();
    });
  }

  render() {
    return (
      <div className="map">
        <MapInfo info={this.state.info} />
        <div id="map-canvas" className="map-canvas" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map.js